<mat-form-field class="full-width form-input" [class.small-text]="compact">
  <mat-label>{{label}}</mat-label>
  <label>
    <input *ngIf="type != 'textarea' && !autoComplete && !options && !errorStateMatcher" matInput #input
           [placeholder]="placeholder || ''"
           [type]="inputType"
           [formControl]="control"
           [autocomplete]="autocomplete"
           [required]="required"
           (blur)="handleOnBlur()"
           (keyup.enter)="handleKeyUpEnter()">
    <input *ngIf="type != 'textarea' && !autoComplete && !options && errorStateMatcher" matInput #input
           [placeholder]="placeholder || ''"
           [type]="inputType"
           [formControl]="control"
           [autocomplete]="autocomplete"
           [required]="required"
           [errorStateMatcher]="errorStateMatcher">

    <input *ngIf="type != 'textarea' && autoComplete && !options" matInput #input
           [placeholder]="placeholder || ''"
           [type]="inputType"
           [formControl]="control"
           autocomplete="off"
           [required]="required"
           [matAutocomplete]="autoComplete">

    <textarea *ngIf="type == 'textarea'" matInput #input
              [placeholder]="placeholder || ''"
              [formControl]="control"
              [required]="required"
              [style]="'height: ' + textAreaHeight"
              class="text-input"></textarea>
  </label>

  <mat-select *ngIf="options"
              [formControl]="control"
              [required]="required"
              [compareWith]="compareWith"
              (selectionChange)="optionSelected($event)">
    <mat-option *ngFor="let option of options" [value]="option">
      {{displayWith(option)}}
    </mat-option>
  </mat-select>
  <mat-hint *ngIf="hint">{{hint}}</mat-hint>

  <button *ngIf="suffixButton && !inProgress" mat-icon-button matSuffix
          [disabled]="!control.value"
          type="button"
          (click)="useSuffixBtn()">
    <mat-icon>{{suffixUsed ? suffixButtonAlt : suffixButton}}</mat-icon>
  </button>

  <mat-spinner *ngIf="inProgress" color="accent" diameter="15" matSuffix></mat-spinner>

  <mat-icon *ngIf="suffixIcon" matSuffix
            [matTooltip]="suffixTooltip"
            [matTooltipDisabled]="!suffixTooltip"
            matTooltipClass="multiline-tooltip"
            class="suffix-icon">{{suffixIcon}}</mat-icon>

  <mat-error *ngIf="control.hasError('required') && control.dirty && !control.hasError('password')">
    <ng-container i18n="Form Validation|Required data missing@@form-validation-input-required">
      {{detailName}} is required
    </ng-container>
  </mat-error>
  <mat-error *ngIf="control.hasError('email') && control.dirty">
    <ng-container i18n="Form Validation|Invalid email@@form-validation-input-invalid-email">
      {{detailName}} should be valid
    </ng-container>
  </mat-error>
  <mat-error *ngIf="control.hasError('pattern') && control.dirty">
    <ng-container i18n="Form Validation|Invalid pattern@@form-validation-input-invalid-patter">
      {{detailName}} is not valid because of invalid characters
    </ng-container>
  </mat-error>
  <mat-error *ngIf="minLength && !maxLength && control.hasError('minlength') && control.dirty">
    <ng-container i18n="Form Validation|Invalid min length@@form-validation-input-invalid-min">
      {{detailName}} should contain more than {minLength, plural, other {{{minLength}} characters}}
    </ng-container>
  </mat-error>
  <mat-error *ngIf="min != undefined && control.hasError('min') && control.dirty">
    <ng-container i18n="Form Validation|Invalid min value@@form-validation-input-invalid-min-value">
      {{detailName}} should be greater than or equal to {{min}}
    </ng-container>
  </mat-error>
  <mat-error *ngIf="max != undefined && control.hasError('max') && control.dirty">
    <ng-container i18n="Form Validation|Invalid max value@@form-validation-input-invalid-max-value">
      {{detailName}} should be less than or equal to {{max}}
    </ng-container>
  </mat-error>
  <mat-error *ngIf="!minLength && maxLength && control.hasError('maxlength') && control.dirty">
    <ng-container i18n="Form Validation|Invalid max length@@form-validation-input-invalid-max">
      {{detailName}} should contain less than {maxLength, plural, other {{{maxLength}} characters}}
    </ng-container>
  </mat-error>
  <mat-error
    *ngIf="minLength && maxLength && (control.hasError('minlength') || control.hasError('maxlength')) && control.dirty">
    <span *ngIf="minLength == maxLength">
      <ng-container
        i18n="Form Validation|Invalid min (with max) length@@form-validation-input-invalid-min-with-max">
        {{detailName}} should contain {minLength, plural, other {{{minLength}} characters}}
      </ng-container>
    </span>
    <span *ngIf="minLength != maxLength">
      <ng-container i18n="Form Validation|Invalid length@@form-validation-input-invalid-length">
        {{detailName}} should contain between {{minLength}} and {maxLength, plural, other {{{maxLength}} characters}}
      </ng-container>
    </span>
  </mat-error>
  <mat-error *ngIf="control.hasError('password') && control.dirty">
    <span *ngIf="control.errors">{{control.errors.password.error}}</span>
    <span *ngIf="!control.errors">
      <ng-container i18n="Form Validation|Invalid password@@form-validation-invalid-password">
        Incorrect {{detailName}}
      </ng-container>
    </span>
  </mat-error>
  <mat-error *ngIf="formGroup && formGroup.hasError('mismatch')">
    <ng-container i18n="Form Validation|Passwords do not match@@form-validation-passwords-do-not-match">
      Passwords do not match
    </ng-container>
  </mat-error>
  <mat-error *ngIf="formGroup && timeErrorCode && formGroup.hasError(timeErrorCode) && timeStart">
    <ng-container i18n="Form Validation|Time range error@@form-validation-time-range-start-error">
      Start time should be before End time
    </ng-container>
  </mat-error>
  <mat-error *ngIf="formGroup && timeErrorCode && formGroup.hasError(timeErrorCode) && !timeStart">
    <ng-container i18n="Form Validation|Time range error@@form-validation-time-range-end-error">
      End time should be after Start time
    </ng-container>
  </mat-error>

  <mat-error *ngIf="control.hasError('phone') && control.dirty">
    <span *ngIf="control.errors">{{control.errors.phone.error}}</span>
    <span *ngIf="!control.errors">
      <ng-container i18n="Form Validation|Invalid phone number@@form-validation-invalid-phone-number">
        Incorrect {{detailName}}
      </ng-container>
    </span>
  </mat-error>

  <mat-error *ngIf="control.hasError('unique') && control.dirty">
    <span *ngIf="control.errors">{{control.errors.unique.error}}</span>
  </mat-error>

  <ng-content></ng-content>
</mat-form-field>
